import { render } from "./add-commentry.vue?vue&type=template&id=a03af86a&scoped=true"
import script from "./add-commentry.vue?vue&type=script&lang=js"
export * from "./add-commentry.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./add-commentry.vue?vue&type=style&index=1&id=a03af86a&scoped=true&lang=css"

import exportComponent from "D:\\MY PROJECTS\\VUE_3\\EXCEL_LIBRARY\\excel-library-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03af86a"]])

export default __exports__